import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../core/auth.service';
import { normalizeText, validateValue } from '../../shared/validation';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [FormsModule, NgIf, RouterLink, MatIconModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  email = '';
  error = '';
  success = '';
  loading = false;

  constructor(private auth: AuthService) {}

  /**
   * Validates the email address and requests a password reset email.
   * @returns void.
   */
  submit() {
    this.error = '';
    this.success = '';
    const email = normalizeText(this.email, true);
    const validationMessage = validateValue('Email address', email, { required: true, kind: 'email' });
    if (validationMessage) {
      this.error = validationMessage;
      return;
    }
    this.email = email;

    this.loading = true;
    this.auth.forgotPassword(email).subscribe({
      next: (result) => {
        this.success = result.message || 'Password reset link sent to your email address';
        this.loading = false;
      },
      error: (error) => {
        this.error = error.error?.message || 'Unable to send reset link';
        this.loading = false;
      }
    });
  }
}
